// For Firebase JS SDK v7.20.0 and later, measurementId is optional
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";
const firebaseConfig = {
  apiKey: "AIzaSyBJ9NbNfkfhNRkCEuILm4QmP1m2frsjbU8",
  authDomain: "twitter-clone-18a0a.firebaseapp.com",
  projectId: "twitter-clone-18a0a",
  storageBucket: "twitter-clone-18a0a.appspot.com",
  messagingSenderId: "122798173771",
  appId: "1:122798173771:web:3ae309e97911e25dc2e7ce",
  measurementId: "G-HM9WZBZNMB",
};

const firebaseApp = firebase.initializeApp(firebaseConfig);

const db = firebaseApp.firestore();

export default db;
